<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card card-w-title">
                <div class="manager-title">Thẩm định sản phẩm</div>
            </div>
            <div class="card card-w-title reformat-title" v-if="$myConstants.checkRoleGroup('appraisal_product', 'add')">
                <div class="list-title">
                    <span class="p-m-0">Tiếp nhận yêu cầu thẩm định</span>
                    <span class="p-input-icon-left">
                        <Button class="p-button-warning" :label="'Quay lại'" @click="backList" />
                        <Button
                            @click="acceptData(true)"
                            :label="'Tiếp nhận và thẩm định'"
                            type="button"
                        > </Button>
                        <Button
                            @click="acceptData()"
                            :label="'Tiếp nhận'"
                            type="button"
                            class="p-button-success"
                        > </Button>
                    </span>
                </div>
                    
                <div class="list-data">
                    <div class="p-grid">
                        <!--<div class="p-field p-col-3">
                            <label >Mã dịch vụ <span class="error">*</span></label>
                            <InputText class="form-control width-300"  disabled="true"  v-model="serviceCode" type="text" />
                        </div>-->
                      <div class="p-field p-col-6">
                        <label >Serial number <span class="" style="font-weight: 400;font-style: italic;">(Hỗ trợ tìm kiếm nhanh đơn vị yêu cầu)</span></label>
                        <span class="p-input-icon-right" >
                          <i class="pi pi-search"/>
                          <InputText maxlength="10" autocomplete="off" type="text"  placeholder="Nhập serial number cần tìm kiếm" style="width: 70%;" v-model="search_serial" @keyup="searchSerialProduct"/>
                        </span>
                        <p ><small v-if="search_serial_err == true"  class="p-invalid" >Không tìm thấy serial number</small></p>
                      </div>
                        <div class="p-field p-col-6">
                            <label >Đơn vị yêu cầu <span class="error">*</span></label>
                          <v-select style="width: 70% !important;" :filterable="false"  placeholder="Chọn đơn vị" v-model="request_organization_id"  :options="optionsRequestOrganization" :reduce="optionsRequestOrganization => optionsRequestOrganization.value"  label="label" @input="changeOrganization" @search="fetchOptionsOrganization"  ><!-- @search="fetchOptionsProductList"-->
                      <span slot="no-options" @click="$refs.select.open = false">
                      {{ $dataCommon.TEXT_NOT_FIND_DATA_SELECT }}
                    </span>
                          </v-select>
<!--                            <Dropdown @input="changeOrganization" class="width-300" style="width: 70% !important;" :filter="true"  v-model="request_organization_id " :options="optionsRequestOrganization" optionLabel="label"  optionValue="value" placeholder="Chọn đơn vị"/>
                          -->  <p ><small v-if="submitCheck && request_organization_id == 0" class="p-invalid" >Chọn đơn vị yêu cầu</small></p>
                        </div>
                        <!--<div class="p-field p-col-3">
                            <label >Người gửi sản phẩm</label>
                             <span class="p-input-icon-right">
                                <div class="p-inputgroup">
                                    <div class="p-inputgroup">
                                        <AutoComplete :dropdown="true" @item-select="clickUsers" @clear="clearUsers"  forceSelection class="width-300 autocomplete-custom"  :disabled="allowSearch"  v-model="selectedUsers" :suggestions="optionsAccounts" @complete="searchUsers($event)" field="label"  placeholder="Tìm kiếm SĐT hoặc tên nhân viên"/>
                                    </div>
                                </div>
                            </span>
                            
                        </div>-->
                    </div>
                    <div class="clearfix"></div>
                    <div class="box-list-product">
                        <div class="p-field">
                            <label><b>Danh sách các sản phẩm đã gửi yêu cầu thẩm định</b></label>
                            <p><i>(Vui lòng chọn những sản phẩm được tiếp nhận thẩm định)</i></p>
                        </div>
                        <div class="box-list-table">
                            <BaseCommon
                                :headerCheckBox="headerTitle"
                                :countCheckBox="true"
                                :labelHeaderAction="'Chi tiết'"
                                :key="componentKey"
                                :listData="listData"
                                :model="dataModel"
                                :filterDefault="filters"
                                :actions="getRowActions()"
                                :isCheckBox="true"
                                :pagination="false"
                                @row-select="onRowSelected"
                                @row-select-all="onRowSelectedAll"
                                v-on:action-click="onActionClicked"
                            ></BaseCommon>
                            <span v-if="request_organization_id > 0 && lstProducts && lstProducts.length == 0 && submitCheck" class="txt-right custom-error">Chọn sản phẩm tiếp nhận thẩm định</span>
                        </div>
                        <div class="p-field">
                            <label><b>Ghi chú</b></label>
                            <textarea maxlength="500" v-model="note" class="form-control" rows="7" placeholder="Nhập ghi chú" ></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseCommon from '../common'
import $ from 'jquery'
export default {
  components: {
    BaseCommon
  },
  data() {
    return {
        search_serial_err:false,
        search_serial:'',
        filters: {},
        listData: [],
        listDataChange: [],
        dataModel: null,
        componentKey: 0,
        headerTitle: 'Chọn',
        modelName: 'request_return_product',
        serviceCode: '',
        user_id: '',
        note: '',
        request_organization_id: 0,
        optionsRequestOrganization: [],
        optionsRequestOrganizationAll: [],
        optionsAccounts: null,
        optionsAllAccounts: [],
        selectedUsers: null,
        allowSearch: true,
        lstProducts: [],
        current_id: 0,
        submitCheck: false
    }
  },
  
  watch: {
    '$route': 'initData'
  },
  async created () {
    await this.initData();
  },
  async mounted () {
    if (this.$route.params.id !== undefined && !isNaN(this.$route.params.id)) {
      this.request_organization_id = Number(this.$route.params.id);
    }
    if (this.$route.params.user !== undefined && !isNaN(this.$route.params.user)) {
      this.current_id = Number(this.$route.params.user);
    }
    if(this.request_organization_id > 0) {
        await this.organizationAccount();
        await this.initParams();
        if (this.current_id > 0) {
            this.searchData();
        }
        this.allowSearch = false;
    }
    // this.enterClickSumit();
  },
  methods: {
    async fetchOptionsOrganization (search, loading) {
      console.log(loading);
      if (!this.$myConstants.isEmpty(search)){
        var list= [];
        var search_convert = this.$myConstants.SkipVN(search).trim();
        for (var i=0;i<this.optionsRequestOrganizationAll.length;i++){
          var textSearch = this.$myConstants.SkipVN(this.optionsRequestOrganizationAll[i].label);
          var keySearch = textSearch.search(search_convert);
          if (keySearch > -1){
            list.push(this.optionsRequestOrganizationAll[i]);
          }
        }
        this.optionsRequestOrganization =list;
      }else {
        this.optionsRequestOrganization = this.optionsRequestOrganizationAll;
      }
      //console.log(this.listChilds)
      return false;
    },
    backList() {
       this.$router.push({path: '/admin/appraisal-product'});
    },
    enterClickSumit() {
        var that = this;
        var input = document.getElementById('keyword');
        input.addEventListener("keyup", function(event) {
            if (event.keyCode === 13) {
                event.preventDefault();
                that.searchData();
            }
        });
    },
    async searchSerialProduct() {
      if (this.search_serial.length == 10){
        var serial_number = this.search_serial.toString().trim().toUpperCase();
        var whereKey = {
          current_status: {'_eq': 0},
          serial_number: {serial_number:{"_eq":serial_number}}
        }
        var variables = {
          where_key: whereKey,
          orderBy: {
            id: 'desc',
            modified_date: 'desc'
          },
          limit: 1
        }
        var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables),"fields": "user_created_request{organization_account{organization_id}} "});
        var list = data[Object.keys(data)];
        if (list.length < 1){
        //Hiển thị lỗi
          this.search_serial_err = true;
          this.$forceUpdate();
          return false;
        }
        var item_data = list[0];
        if (this.$myConstants.isEmpty(item_data.user_created_request)){
          //hiển thị lỗi
          this.search_serial_err = true;
          this.$forceUpdate();
          return false;
        }
        if (this.$myConstants.isEmpty(item_data.user_created_request.organization_account)){
          //hiển thị lổi
          this.search_serial_err = true;
          this.$forceUpdate();
          return false;
        }
        if (this.$myConstants.isEmpty(item_data.user_created_request.organization_account.organization_id)){
          //hiển thị lổi
          this.search_serial_err = true;
          this.$forceUpdate();
          return false;
        }
        //autofill đơn vị
        var organization_id = item_data.user_created_request.organization_account.organization_id;
        this.search_serial_err = false;
        this.request_organization_id = organization_id;
        this.changeOrganization(organization_id);

      }else {
        this.search_serial_err = false;
      }
    }
    ,
    async changeOrganization($event) {
      console.log("$event$event:",$event)
        this.request_organization_id = $event;
        this.allowSearch =  $event > 0 ? false : true;
        if(this.request_organization_id > 0) {
            this.user_id = '';
            this.selectedUsers = null;
            await this.initParams();
            await this.organizationAccount();
        }
    },
    async organizationAccount() {
        if (this.request_organization_id > 0) {
            this.optionsAllAccounts = [];
            var listUsers = this.listData.map(a => a.user_created);
            var resultUsers = listUsers.reduce((unique, o) => {
                if(!unique.some(obj => obj === o)) {
                  unique.push(o);
                }
                return unique;
            },[]);
            listUsers = resultUsers;
            
            var whereKey = {
                status: {'_in': [1] },
                organization_account: {
                    organization_id: {'_eq': this.request_organization_id}
                }
            }

            if(listUsers && listUsers.length) {
                whereKey = Object.assign(whereKey, {id: {'_in': listUsers}}); 
            }

            var variables = {
                where_key: whereKey
            }
        }
        var data = await DataServices.getList('users', {"variables": JSON.stringify(variables), "fields": "id phone_number full_name"});
        var list = data[Object.keys(data)];
        if (list !== undefined && list !== null && Object.keys(list).length) {
            for (let index = 0; index < list.length; index++) {
                const item = list[index];
                var text = item.full_name;
                if (item.phone_number != '') {
                    text = item.phone_number.replace('+84', '0') + ' - ' + text;
                }
                var objOption = {label: text, value: item.id, item: item};
                this.optionsAllAccounts.push(objOption);
                if(this.current_id > 0 && this.current_id == item.id) {
                    this.selectedUsers = objOption;
                    this.user_id = this.current_id;
                }
            }
        }
    },
    
    clickUsers(event) {
        this.user_id = event.value.value;
        //this.searchData();
    },
    clearUsers() {
        this.user_id = '';
        this.selectedUsers =  null;
        this.optionsAccounts = this.optionsAllAccounts;
        this.searchData();
    },
    searchUsers(event) {
        var that = this;
        setTimeout(() => {
            if (!event.query.trim().length) {
                that.optionsAccounts = [...that.optionsAllAccounts];
            }
            else {
                that.optionsAccounts = that.optionsAllAccounts.filter((user) => {
                    var labelData = user.label.trim().toLowerCase();
                    var labelFilter = event.query.trim().toLowerCase();
                    labelData = that.$myConstants.cleanAccents(labelData, '');
                    labelFilter = that.$myConstants.cleanAccents(labelFilter, '');
                    return labelData.indexOf(labelFilter) >= 0;
                });
            }
        }, 100);
    },
    async initData() {
        this.dataModel = DataServices.getModel(this.modelName);
        await this.requestOrganization();
    },
    async requestOrganization() {
      var variables = {
        where_key: {
            current_status: {'_eq': 0},
            user_created_request: {
                organization_account: {
                    organization: {
                      status: {'_in': [1]}
                    }
                }
            }
        }
      }
      var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables), "distinct": " user_created ",  "fields": "user_created_request { organization_account { organization { id name }}}"});
      var list = data[Object.keys(data)];
      if (list !== undefined && list !== null && Object.keys(list).length) {
        for (let index = 0; index < list.length; index++) {
          const item = list[index];
          if (item.user_created_request != undefined && item.user_created_request != null) {  
            var userCreatedRquest = item.user_created_request;
            if(userCreatedRquest.organization_account != undefined && userCreatedRquest.organization_account != null) {
                var organization_account = userCreatedRquest.organization_account;
                if (organization_account.organization != undefined && organization_account.organization != null) {
                    var organization = organization_account.organization;
                    this.optionsRequestOrganization.push({label: organization.name, value: organization.id});
                } 
            }
          }
        }
      }
      if(this.optionsRequestOrganization) {
        var resultOrganization = this.optionsRequestOrganization.reduce((unique, o) => {
            if(!unique.some(obj => obj.value === o.value)) {
                unique.push(o);
            }
            return unique;
        },[]);
        this.optionsRequestOrganization = resultOrganization;
      }
      this.optionsRequestOrganizationAll = this.optionsRequestOrganization;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.filter = { name: 'clear', icon: 'times-circle'};
      actions.rows = function (rowData) {
        var buttons = {}
        buttons.view = { name: 'view', text: 'Xem', isText: true, key: 'id', path: `/admin/appraisal-product/view-detail`}
        if (that.dataModel.actions) {
            var modelaction = that.dataModel.actions(rowData)
            Object.assign(buttons, modelaction);
        }
        
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
        if (action.path !== undefined && action.path) {
            var queries = {};
            if (this.request_organization_id > 0) {
                queries = Object.assign(queries, {id: this.request_organization_id});
            }
            if (this.user_id > 0) {
                queries = Object.assign(queries, {user: this.user_id});
            }
            this.$router.push({ path: action.path + '/' + data.data[action.key] , query: queries})
        }
        break;
      }
    },
    onRowSelectedAll(data) {
      this.lstProducts = data;
    },
    onRowSelected(data) {
      this.lstProducts = data;
    },
    searchData() {
        var that = this;
        if (that.user_id != '') {
            // var userID = this.optionsAllAccounts.filter(function(obj) {
            //     var textUser = that.selectedUsers.toString().trim().toLowerCase();
            //     textUser = that.$myConstants.cleanAccents(textUser,'');
            //     var textItem = obj.label.toString().trim().toLowerCase();
            //     textItem = that.$myConstants.cleanAccents(textItem,'');
            //     var phoneNumber = (obj.item.phone_number != undefined && obj.item.phone_number != null) ? obj.item.phone_number.replace('+84', '0') : '';
            //     if( textItem == textUser || (phoneNumber != '' && phoneNumber == textUser)) return obj.value;
            // });
            // var arrUsers = [];
            // if (userID && Object.keys(userID).length > 0) {
            //     arrUsers = that.user_id
            // }
            // this.listData = this.listDataChange.filter(function (obj) {
            //     return arrUsers.includes(obj.user_created);
            // });
            this.listData = this.listDataChange.filter(function (obj) {
                return that.user_id == obj.user_created;
            });
            this.componentKey = Math.random() * 10;
        } else {
            this.initParams();
        }
    },
    async initParams() {
        
        this.$store.commit('setDataLoading', {content: 'Đang tải dữ liệu', icon: true});
        this.$store.commit('setLoading', true);
        var whereKey = {
            current_status: {'_eq': 0}
        }
        if (this.request_organization_id > 0) {
            whereKey = Object.assign(whereKey, {
                user_created_request: {
                    organization_account: {
                        organization_id: {'_eq': this.request_organization_id}
                    }
                }
            });
        }
        var variables = {
            where_key: whereKey,
            orderBy: {
                id: 'desc',
                modified_date: 'desc'
            }
        }
        var data = await DataServices.getList(this.modelName, {"variables": JSON.stringify(variables)});
        var list = data[Object.keys(data)];
        this.dataModel.processData(list);
        this.listData = list;
        this.listDataChange = list;
        this.componentKey = Math.random() * 100;
        this.$store.commit('setLoading', false);
    },
  
    async createCode() {
        var date = new Date();
        var number = 1;
        var autoNumber = 1;
        var code = '';
        var codeTmp = '';
        var variables = {
            where_key: {},
            orderBy: {
                id: 'desc'
            },
            limit: 1
        }
        var data = await DataServices.getList('appraisal', {"variables": JSON.stringify(variables), "field": " id code"});
        var list = data[Object.keys(data)];
        if (list != null) {
           var item = list[0];
           if(item != undefined && item != null) code = item.code;
        }
      
        if (code != '') {
            var arrCode = code.split(/-/);
            if (arrCode.length == 2) {
                autoNumber += Number(arrCode[1]);
            }
        }
        number = this.request_organization_id;
        codeTmp = 'TD' + date.getFullYear().toString().substr(-2) + '' + this.$myConstants.autoGenerateZeroMinLength(number, 5) + '-' + this.$myConstants.autoGenerateZeroMinLength(autoNumber, 4);
        return codeTmp;
    },
    async processAccept(info, appraisalID, codeAuto) {
        var paramsProduct = {
            appraisal_id: appraisalID,
            serial_number_id: info.serial_number_id,
            request_return_product_id: info.id,
            user_id: this.$store.getters.fullname.id,
            current_status: 1,
            note: `Tiếp nhận thẩm định sản phẩm. Mã dịch vụ: <a href="/admin/appraisal-product/view/${appraisalID}"><span style="color:#0099FF;">${codeAuto}</span></a>`,
            created_date: this.$myConstants.currentDate(),
            modified_date: this.$myConstants.currentDate()
        }
        var returnData  = await DataServices.insertData('appraisal_product', {"variables": JSON.stringify({objects: paramsProduct})});
        if (returnData != null) {
            var checkData = returnData[Object.keys(returnData)];
            if (checkData.affected_rows > 0) {
                var returning = checkData.returning[0];
                var appraisalProductID = returning.id;
                await DataServices.updateData('request_return_product', {"variables": JSON.stringify({data_update: {current_status: 1}, where_key: {id: {'_eq': info.id}}})});
                
                var paramsProductProcess = {
                    request_return_product_id: info.id,
                    user_id: this.$store.getters.fullname.id,
                    return_status: 1,
                    note: `Tiếp nhận thẩm định sản phẩm. Mã dịch vụ: <a href="/admin/appraisal-product/view/${appraisalID}"><span style="color:#0099FF;">${codeAuto}</span></a>`,
                    created_date: this.$myConstants.currentDate(),
                    modified_date: this.$myConstants.currentDate(),
                    warranty_status: (info.serial_number_product != undefined && info.serial_number_product != null && info.serial_number_product.warranty_status != undefined && info.serial_number_product.warranty_status != null) ? info.serial_number_product.warranty_status : 3,
                    appraisal_product_id: appraisalProductID
                }
                var returnDataprocess  = await DataServices.insertData('request_return_product_process', {"variables": JSON.stringify({objects: paramsProductProcess})});
                if (returnDataprocess != null) {
                    var checkDataprocess = returnDataprocess[Object.keys(returnDataprocess)];
                    return checkDataprocess.affected_rows > 0;
                }
            }
        }
        return false
    },

    async acceptData(approval = false) {
        this.submitCheck = true;
        if (this.request_organization_id > 0 && this.lstProducts.length > 0) {
            this.$store.commit('setDataLoading', {content: 'Đang lưu dữ liệu', icon: true});
            this.$store.commit('setLoading', true);
            var codeAuto = await this.createCode();
            var organizationID = 0;
            var returning = null;
            var organization = this.$myConstants.organizationUserLogin();
            if (organization != null) organizationID = organization.id;
            var params = {
                code: codeAuto,
                user_id: this.$store.getters.fullname.id,
                request_organization_id: this.request_organization_id,
                organization_id: organizationID,
                note: this.note,
                created_date: this.$myConstants.currentDate(),
                modified_date: this.$myConstants.currentDate(),
                status: 0
            }
            var returnData  = await DataServices.insertData('appraisal', {"variables": JSON.stringify({objects: params})});
            if (returnData != null) {
                var checkData = returnData[Object.keys(returnData)];
                if (checkData.affected_rows > 0) {
                    returning = checkData.returning[0];
                }
            }

            if (returning != null){
                var appraisalID = returning.id;
                var k = 0;
                var stop = false;
                while (k < this.lstProducts.length) {
                    await this.processAccept(this.lstProducts[k], appraisalID, codeAuto);
                    if (k == (this.lstProducts.length - 1)) {
                        stop = true;
                    }
                    k++;
                }
                this.$store.commit('setLoading', false);
               
                if (stop) {
                    this.$toast.add({ severity: 'success', summary: 'Thông báo', detail: 'Tạo mới thành công', life: 3000 })
                    if (approval) {
                        this.$router.push({path: '/admin/appraisal-product/view/' + appraisalID});
                    } else {
                        this.$router.push({path: '/admin/appraisal-product'});
                    }
                }
            }
        } else {
            if (this.request_organization_id == 0) $('body').find('.p-datatable-emptymessage').find('td').text("Không có dữ liệu. Vui chọn Đơn vị yêu cầu.");
        }
    }
  }
}
</script>

<style lang="scss">
.reformat-title{ padding: 1.5em !important;
    .list-title {background: transparent !important; border: 1px solid #ccc;}
    .p-input-icon-left{
        button{margin-right: 20px;
            &:last-child{margin: 0;}
        }
    }
    .list-data{ padding: 1.5em !important;  border: 1px solid #ccc; border-top: 0;
        .p-field{
            label{font-weight: bold; display: block;}
            .custom-button-input-group {color: #333; background: transparent; border: 1px solid #a6a6a6; border-left: none;}
        }
        .width-300{width: 300px !important;
            &.p-autocomplete{
                .p-autocomplete-input{width: 300px !important;}
            }
        }
        .box-list-product{margin-top: 20px;
            .box-list-table{margin-bottom: 30px;
                .custom-error{display: block; color: #f00; margin-top: 10px; font-style: italic;}
            }
        }
        
    }
    .custom-header {
        abbr{color: #f00; font-weight: 600; padding-left: 5px;}
    }
}
.autocomplete-custom{
    input{border-right: none;border-top-right-radius: 0px !important; border-bottom-right-radius: 0px !important;}
    .p-autocomplete-dropdown{ background: transparent; border: 1px solid #a6a6a6; border-left: none;width: 50px;
        &:enabled:hover{background: transparent; border: 1px solid #a6a6a6; border-left: none;}
        span{font-weight: 900; font-size: 20px; color: #C0C0C0;
            &::before{ content: "\e908";}
        }
    }   
}

</style>